<div>
	<div class="compliance-outer">
		<h2 class="compliance-header text-center mb-4">Meet Our Tech Stack</h2>
		<p class="ready-set-content text-center mb-5">
			Manufactured with enterprise-grade tools that maximize performance,
			security,<br class="d-none d-md-block" />
			and scalability to meet the most demanding customer requirements.
		</p>
	</div>
	<div class="compliance-container">
		<div class="compliance-container-inner">
			<img
				class="d-none d-md-block orange-pattern-overlay"
				src="../../assets/img/orange-pattern.png"
				alt=""
			/>
			<img
				class="d-md-none orange-pattern-overlay"
				src="../../assets/img/orange-pattern-mobile.png"
				alt=""
			/>
			<div class="grid-wrapper text-center">
				<div class="row">
					<div class="col-md-3 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/packaging.svg"
							alt=""
						/>
						<div class="challenges-list-head">Packaging</div>
						<div class="challenges-list-content">
							Deploy independently in a Docker
							<br class="d-none d-md-block" />
							container or scale RegScale using
							<br class="d-none d-md-block" />
							various orchestration systems such as
							<br class="d-none d-md-block" />
							Kubernetes, Docker Swarm, and
							<br class="d-none d-md-block" />
							Amazon ECS.
						</div>
					</div>
					<div class="col-md-3 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/frontend.svg"
							alt=""
						/>
						<div class="challenges-list-head">Front-End</div>
						<div class="challenges-list-content">
							Angular Single Page Application (SPA) with a
							<br class="d-none d-md-block" />
							responsive design based on Bootstrap that
							<br class="d-none d-md-block" />
							works on any device, anywhere, anytime.
						</div>
					</div>
					<div class="col-md-3 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/middle-tier.svg"
							alt=""
						/>
						<div class="challenges-list-head">Middle-Tier</div>
						<div class="challenges-list-content">
							Get enterprise-grade security, industry-<br
								class="d-none d-md-block"
							/>leading performance, and scalability through
							<br class="d-none d-md-block" />
							Open REST APIs based on the .NET Core
							<br class="d-none d-md-block" />
							languages.
						</div>
					</div>

					<div class="col-md-3 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/backend.svg"
							alt=""
						/>
						<div class="challenges-list-head">Back-End</div>
						<div class="challenges-list-content">
							SQL Server database which can be clustered
							<br class="d-none d-md-block" />
							for scalability leveraging enterprise security
							<br class="d-none d-md-block" />
							features.
						</div>
					</div>
				</div>
				<a [routerLink]="['/pricing']">
					<button class="complaince-button py-2 px-5 mt-2 mt-lg-5">
						Get Started for Free
					</button></a
				>
			</div>
		</div>
	</div>
</div>
